import styled from "styled-components";
import {ITopCategory} from "../interfaces/ITopCategory";
import {getTheme} from "../shared/themeUtils";
import {useMessages} from "../hooks/useMessages";

const Contain = styled.div`
  position: absolute;
  top: -2px;
  left: 0;
  z-index: 2;
  opacity: .8;
  .tag {
    display: inline-block;
    border-top-left-radius: 3px;
    border-bottom-right-radius: ${getTheme("borderRadius")};
    padding: 0 ${getTheme("space.1")};
    font-size: ${getTheme("fontSizes.small")};
    font-weight: 600;
  }
  
  .tag-sale {
    background: ${getTheme("colors.backgroundRed")};
    color: ${getTheme("colors.textRed")};
  }

  .tag-new {
    background: ${getTheme("colors.backgroundBlue")};
    color: ${getTheme("colors.textBlue")};
  }

  .tag-demo {
    background: ${getTheme("colors.backgroundOrange")};
    color: ${getTheme("colors.textOrange")};
  }

  .tag-limited {
      background: ${getTheme("colors.backgroundColumbiaBlue")};
      color: ${getTheme("colors.textCrayolaBlue")};
  }
`

type TagPropsTypes = {
  productTarget?: any,
  categoryTarget?: ITopCategory,
  type: "product" | "category",
  className?: string,
  ribbonText?: string
}

const Tag = (props: TagPropsTypes) => {
  const {productTarget, categoryTarget, type, ribbonText} = props;
  const messagesQuery = useMessages()

  return (
    <Contain className={props.className}>
      {messagesQuery.data &&
        <>
          {(type == "product" && productTarget) && <>
            {productTarget.isSale &&
              <div className="tag tag-sale">
                {productTarget.referenceDiscount != null && <span>{productTarget.referenceDiscount}</span>}
                {productTarget.referenceDiscount == null && <span>sale</span>}
              </div>
            }

            {productTarget.isNew &&
              <div className="tag tag-new">
                <span>new</span>
              </div>
            }

            {productTarget.isDemo &&
              <div className="tag tag-demo">
                <span>{messagesQuery.data.messages["b-stock"]}</span>
              </div>
            }

            {productTarget.isLimited &&
              <div className="tag tag-limited">
                <span>Ltd</span>
              </div>
            }
          </>}

          {(type == "category" && categoryTarget) && <>
            {categoryTarget.websiteTag == "blowout" &&
              <div className="tag tag-sale">
                <span>{ribbonText}</span>
              </div>
            }

            {categoryTarget.websiteTag == "blackfriday24" &&
              <div className="tag tag-sale">
                <span>{ribbonText}</span>
              </div>
            }

            {categoryTarget.websiteTag == "new" &&
              <div className="tag tag-new">
                <span>{ribbonText}</span>
              </div>
            }

            {categoryTarget.websiteTag == "demo" &&
              <div className="tag tag-demo">
                <span>{messagesQuery.data.messages["b-stock"]}</span>
              </div>
            }

            {categoryTarget.websiteTag == "limited" &&
              <div className="tag tag-limited">
                <span>Ltd</span>
              </div>
            }
          </>}
        </>}
    </Contain>
  )
}

export default Tag;